import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { TeamAndGovernanceForm, TeamGovernanceSubmitFields } from './team-governance-form-new';

export type TeamGovernanceDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly isOpen: boolean;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
};

export function TeamGovernanceDrawer({ formId, project, isOpen, onSubmit, onClose }: TeamGovernanceDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Team & Governance')} open={isOpen} onClose={onClose} footer={footer}>
      <TeamAndGovernanceForm
        id={formId}
        project={project}
        onSubmit={(data: TeamGovernanceSubmitFields) =>
          onSubmit({ team_and_governance: [data] }, t('Team & Governance has been updated'))
        }
      />
    </Drawer>
  );
}
